import React from 'react';

import classes from './TrdResultLess.css';

const trdResult = (props) => {

   
    let resultClass = [classes.TrdResultL]

    if ( props.highlight ){
        resultClass.push(classes.Highlight)
    }


    return (
        <div className={resultClass.join(' ')}>
            <div className={classes.IndexL}>
                <p>{props.index + 1}.</p>
            </div>
            <div className={classes.RegNameL}>
                <p>{props.name}</p>
            </div>
        </div>
    )
}

export default trdResult;


// WEBPACK FOOTER //
// ./src/components/UI/TrdAdminFocus/TrdResultLess/TrdResultLess.js